<template>
  <div>
    <div class="row m-b-40" v-if="allowed_goods_types_array.length > 1">
      <div
        v-if="allowed_goods_types_array.indexOf('2') > -1"
        :class="goodsTypesSizeCLass">
        <div
          :class="activeGoodsType === 2 ? 'active brand' : 'light'"
          class="button-bar"
          @click="setActiveGoodsType(2)">
          <Icon
            class="m-r-20"
            name="documentGoods"
            :circle="true"
            size="20"/>
          <div class="text-box">
            <span class="main-text">{{ $t('document') }}</span>
          </div>
        </div>
      </div>
      <div v-if="allowed_goods_types_array.indexOf('1') > -1"
           :class="goodsTypesSizeCLass">
        <div
          :class="activeGoodsType === 1 ? 'active brand' : 'light'"
          class="button-bar"
          @click="setActiveGoodsType(1)">
          <Icon
            class="m-r-20"
            name="savedItems"
            :circle="true"
            size="20"/>
          <div class="text-box">
            <span class="main-text">{{ $t('parcel') }}</span>
          </div>
        </div>
      </div>
      <div v-if="allowed_goods_types_array.indexOf('3') > -1"
           :class="goodsTypesSizeCLass">
        <div
          :class="activeGoodsType === 3 ? 'active brand' : 'light'"
          class="button-bar"
          @click="setActiveGoodsType(3)">
          <Icon
            class="m-r-20"
            name="pallet"
            :circle="true"
            size="20"/>
          <div class="text-box">
            <span class="main-text">{{ $t('pallet') }}</span>
          </div>
        </div>
      </div>
      <div v-if="allowed_goods_types_array.indexOf('4') > -1"
           :class="goodsTypesSizeCLass">
        <div
          :class="activeGoodsType === 4 ? 'active brand' : 'light'"
          class="button-bar"
          @click="setActiveGoodsType(4)">
          <Icon
            class="m-r-20"
            name="delivery"
            :circle="true"
            size="20"/>
          <div class="text-box">
            <span class="main-text">{{ $t('load') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters} from "vuex";

export default {
  props: {
    value: {
      type: [String, Number],
    },
  },
  data() {
    return {
      allowed_goods_types_array: [],
      activeGoodsType: ''
    };
  },
  created() {
    this.allowed_goods_types_array = this.get_user.allowed_goods_types_array;
    this.activeGoodsType = this.value
  },
  computed: {
    ...mapGetters([
      'get_user',
      'get_editing_shipment',
    ]),
    goodsTypesSizeCLass() {
      if(this.allowed_goods_types_array.length === 4) {
        return 'col-xs-3';
      }
      if(this.allowed_goods_types_array.length === 3) {
        return 'col-xs-4';
      }
      if(this.allowed_goods_types_array.length === 2) {
        return 'col-xs-6';
      }
      if(this.allowed_goods_types_array.length === 1) {
        return 'col-xs-12';
      }

      return 'col-xs-12';
    },
  },
  methods: {
    setActiveGoodsType(type){
      this.activeGoodsType = type;
      this.$emit('activeGoodsType', type);
    },
  }
}
</script>
